import CreateAPI from 'vue-create-api'

export default function createAPI(Vue, Component, events, single) {
  Vue.use(CreateAPI, {
    componentPrefix: 't-',
    apiPrefix: '$'
  })
  const api = Vue.createAPI(Component, events, single)
  return api
}



// WEBPACK FOOTER //
// ./src/module/loading/create-api.js